// removed by extract-text-webpack-plugin
module.exports = {"dark":"dark","project_list":"project_list","header":"header","project_item":"project_item","flex":"flex","addresses_count":"addresses_count","option":"option"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/ProjectsList/style_dark.scss
// module id = 491
// module chunks = 0